import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { DegreeAuditService } from '../../services/degree-audit.service';
import { ProfileService } from '../../core/services/profile.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConcentrationsModalComponent } from '../../core/modals/concentrations/concentrations.component';


@Component({
    selector: 'my-degree',
    templateUrl: './my-degree.component.html',
    styleUrls: ['./my-degree.component.scss'],
    standalone: false
})
export class MyDegreeComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;
    public showAllConcentrations = false;

    constructor(
        private logger: LoggerService,
        public degreeAudit: DegreeAuditService,
        public profileService: ProfileService,
        private modalService: NgbModal,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MyDegree, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    toggleConcentrationView() {
        this.showAllConcentrations = !this.showAllConcentrations;
    }
    
    public openConc(concentrations) {
        this.profileService.refetchConcentrationData();
        const modelRef = this.modalService.open(ConcentrationsModalComponent, { ariaLabelledBy: 'modal-basic-title' });
        modelRef.componentInstance.type = (concentrations && concentrations.length > 0 ) ? concentrations[0].Type:'';
        modelRef.componentInstance.numConc = concentrations ? concentrations.length : 0;
        modelRef.result.then((result) => { // If the modal was closed with save, then update the concentrations                 
                this.profileService.saveConcentration(result);
            },
                (result) => {}); // otherwise, ignore the result 
    }

    public getInProgressLocation(degreeDetail) {      
        return degreeDetail.PercentageRemaining > 15 ? 100 - degreeDetail.PercentageRemaining + (degreeDetail.PercentageRemaining - 1) / 2 : 15;
    }
}

